module.exports = __webpack_public_path__ + "img/effect.4d3b1698.png";